module.exports = __webpack_public_path__ + "static/media/user_type_provider.2bb6df8e.svg";